import { render, staticRenderFns } from "./SearchMaterials.vue?vue&type=template&id=6676fe68&scoped=true"
import script from "./SearchMaterials.vue?vue&type=script&lang=ts"
export * from "./SearchMaterials.vue?vue&type=script&lang=ts"
import style0 from "./SearchMaterials.vue?vue&type=style&index=0&id=6676fe68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676fe68",
  null
  
)

export default component.exports